import React from 'react';
import { Wrapper, TopArea, BottomArea, CardArea, CardTextArea, Image } from './Board.styled';
import { Button, AvatarRectangle, Subtitle, AvatarCircle } from '@/components/atoms';
import { CATEGORY, PLACEHOLDER_TOP_BANNER } from '@/const';
import { IBoardItem } from '@/types';

const Board = (props: IBoardItem) => {
  const { iconUrl, ctaName, title, subTitle, onClickBoard, onClickButton, imgPath, adCategoryCd } =
    props;

  const handleClickButton = () => {
    ctaName && onClickButton();
  };

  const handleClickBoard = () => {
    !ctaName && onClickBoard();
  };

  return (
    <Wrapper onClick={handleClickBoard}>
      <TopArea hasButton={ctaName}>
        <Image src={imgPath || PLACEHOLDER_TOP_BANNER} alt={title} loading="lazy" />
      </TopArea>
      <BottomArea hasButton={ctaName}>
        <CardArea hasButton={ctaName}>
          {/* {CATEGORY[adCategoryCd] === 'card' && <AvatarRectangle src={iconUrl} alt={title} />}
          {CATEGORY[adCategoryCd] !== 'card' && <AvatarCircle src={iconUrl} alt={title} />} */}
          <AvatarCircle src={iconUrl} alt={title} />
          <CardTextArea>
            <Subtitle level={3} color="gary-800" ellipsis>
              {title}
            </Subtitle>
            <Subtitle level={6} ellipsis>
              {subTitle}
            </Subtitle>
          </CardTextArea>
        </CardArea>
        {ctaName && <Button onClick={handleClickButton}>{ctaName}</Button>}
      </BottomArea>
    </Wrapper>
  );
};

export default React.memo(Board);
